// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../common/JQueryView';

export default class EditView extends JQueryView {
  constructor() {
    super('.modal-dialog');

    this.checkSelectValue();
  }

  @on({ event: 'change', selector: '#user_recent_company_id' })
  onChangeUserRecentCompanyIdSelect() {
    this.checkSelectValue();
  }

  // selectの値によるログインボタン非活性切り替え
  checkSelectValue() {
    if ($('#user_recent_company_id').val() === '') {
      $('.js-submit-btn').prop('disabled', true);
      $('.js-submit-btn').addClass('btn-action');
    } else {
      $('.js-submit-btn').prop('disabled', false);
      $('.js-submit-btn').removeClass('btn-action');
    }
  }
}
